// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
  }
};

(function() {

  BoostPFS.inject(this); // Add this
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if (jQ(searchBoxId).closest('.search_container').length > 0) {
      this.setSuggestionWidth(searchBoxId, 400);
    }
  };

  /* Fix search issue on mobile */
  InstantSearch.prototype.init = function() {
    var inputElements = jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]:not([data-disable-instant-search])');
    inputElements.each((index, inputElement) => {

      if (jQ(inputElement).attr('id') == 'q' && Utils.isMobile()) {
        var id = jQ(inputElement).attr('id');
      } else {
        var id = 'boost-pfs-search-box-' + index;
      }
      var searchBox = new SearchInput(id, jQ(inputElement));
      this.addComponent(searchBox);
    });
    // Build search input for mobile
    if (Utils.isMobile()) {
      // Clear cache when going back from another page
      window.onpageshow = (event) => {
        if (event.persisted) {
          window.location.reload();
        }
      }
      // Build Suggestion mobile on top
      if (Settings.getSettingValue('search.suggestionMobileStyle') !== InstantSearchEnum.Mobile.SuggestionType.STYLE_2) {
        var instantSearchMobile = InstantSearchStyle.instantSearchMobile();
        this.addComponent(instantSearchMobile);
      }
    }
    // Build search input for style3
    if (!Utils.isMobile() && Settings.getSettingValue('search.suggestionStyle') === 'style3' || Settings.getSettingValue('search.suggestionColumn') === '2-overlay-fullwidth') {
      var instantSearchStyle3 = InstantSearchStyle.instantSearchStyle3();
      this.addComponent(instantSearchStyle3);
    }
  };

  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function (isClose) {
    jQ('.close-search').click();
  }
  Utils.buildProductItemUrl = function(data, hasCollection) {
      console.log('buildProductItemUrl');
      // Get url information
      var params = Utils.getWindowLocation().search.substring(1);
      var pathname = window.location.pathname;
      var elements = pathname.split('/');
    
      // Check if has locale
      var localeURLPart = "";
      var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
      if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
      } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
      }
    
      // Get product handle
      var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
      var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
      if (hasCollection) {
        // Homepage or Search page
        if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
          var preHandle = localeURLPart + '/collections/all/products/';
          return preHandle + handle;
    
          // Tag Page
        } else if (Utils.isTagPage()) {
          var preHandle = localeURLPart + '/collections/';
          var collectionHandleIndex = elements.indexOf("collections") + 1
          if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          return '/collections/all/products/' + handle;
        } else {
          // Google cache URL
          // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
          if (params.indexOf('cache:') > -1) {
            var collectionHandle = 'all';
            var temp = params.split('&')[0].split('?')[0].split('collections/');
            if (temp.length > 1) {
              if (temp[1].indexOf('/') > -1) {
                collectionHandle = temp[1].split('/')[0];
              } else {
                collectionHandle = temp[1];
              }
            }
            collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
            return '/collections/' + collectionHandle + '/products/' + handle;
          }
          var collectionHandleIndex = elements.indexOf("collections") + 1;
          var preHandle = localeURLPart + '/collections/';
          
          if (typeof elements[2] !== 'undefined') {
            // Build for collection pages
            if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
              return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
            }
            //Build for other pages, use collection/all
            return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
          } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
            return '/products/' + handle;
          }
          return window.location.pathname + '/products/' + handle;
        }
      }
      return localeURLPart + '/products/' + handle;
    };

})();